import SupplierForm from './SupplierForm'
export default SupplierForm
